import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsList";
import { i18n } from "../../translate/i18n";
import { Button } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    background: theme.palette.background.paper,
    padding: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch"
    }
  },
  ticketActionsRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "space-between"
    }
  },
  newTicketButton: {
    [theme.breakpoints.down("sm")]: {
      flex: 1
    }
  },
  searchInputWrapper: {
    flex: 1,
    width: "100%",
    background: theme.palette.background.default,
    display: "flex",
    borderRadius: 40,
    padding: 4
  },
  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center"
  },
  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 30,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default
  }
}));

const TicketsManager = () => {
  const classes = useStyles();
  const [searchParam, setSearchParam] = useState("");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [selectedQueueIds] = useState([]);
  const searchInputRef = useRef();
  const searchTimeoutRef = useRef(null);

  useEffect(() => {
    searchInputRef.current?.focus();
  }, []);

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  const handleSearch = e => {
    const searchedTerm = e.target.value.toLowerCase();

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      setSearchParam(searchedTerm);
    }, 300);
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={() => setNewTicketModalOpen(false)}
      />

      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <div className={classes.ticketActionsRow}>
          <div className={classes.searchInputWrapper}>
            <SearchIcon className={classes.searchIcon} />
            <InputBase
              className={classes.searchInput}
              inputRef={searchInputRef}
              placeholder={i18n.t("tickets.search.placeholder")}
              type="search"
              onChange={handleSearch}
            />
          </div>

          <Button
            variant="outlined"
            color="primary"
            onClick={() => setNewTicketModalOpen(true)}
            className={classes.newTicketButton}
          >
            {i18n.t("ticketsManager.buttons.newTicket")}
          </Button>
        </div>
      </Paper>

      <Paper className={classes.ticketsWrapper}>
        <TicketsList
          status="open,pending,closed"
          searchParam={searchParam}
          showAll={true}
          selectedQueueIds={selectedQueueIds}
        />
      </Paper>
    </Paper>
  );
};

export default TicketsManager;
